function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Search = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M21.07 19.65l-5-5a7.5 7.5 0 1 0-1.41 1.41l5 5a1 1 0 0 0 1.41-1.41zm-6.72-5.3a6 6 0 1 1 0-8.49 6 6 0 0 1 0 8.49z"
}, " "));

Search.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Search;